import React, { useState } from 'react';
import ModelConfig from './ModelConfig';
import PriceInfo from './PriceInfo';

// Sekcja pojedynczego modelu - wykorzystuje backend preview i API
const ModelSection = ({ model, onRemove, onUpdate }) => {
    const [isConfigExpanded, setIsConfigExpanded] = useState(false);
    return (
        <div className="container model-container">
        {/* Przycisk usuwania modelu */}
        <button
        onClick={onRemove}
        className="model-remove-btn"
        title="Usuń model"
        >
        ×
        </button>

        <div className="p-3">
        {/* Główny layout - 3 kolumny zawsze widoczne */}
        <div className="model-layout">
        {/* Lewa kolumna - preview z backend i informacje */}
        <div>
        {/* Preview z backend lub placeholder */}
        {model.thumbnailUrl ? (
            <img
            src={`${process.env.REACT_APP_BACKEND_URL}${model.thumbnailUrl}`}
            alt={"preview"}
            className="model-thumbnail"
            />
        ) : (
            <div className="model-thumbnail-placeholder">
            {model.error ? '❌ Błąd' : '📦 Model 3D'}
            </div>
        )}

        <div className="mt-2">
        <div className="model-name"> {model.name} </div>
        <div className="text-small"> {model.dimensions.x.toFixed(1)} × {model.dimensions.y.toFixed(1)} × {model.dimensions.z.toFixed(1)} cm </div>
        <div className="text-small"> {model.volume.toFixed(2)} cm³ </div>
        {model.hasSupports !== undefined && (<div className="text-small"> Druk z podporami: {model.hasSupports ? 'TAK' : 'NIE'} </div>)}
        </div>
        </div>

        {/* Środkowa kolumna - kompaktowa konfiguracja (zawsze widoczna) */}
        <div className="model-config-column">
        <ModelConfig model={model} onUpdate={onUpdate} isConfigExpanded={isConfigExpanded} setIsConfigExpanded={setIsConfigExpanded}/>
        </div>

        {/* Prawa kolumna - ilość i cena */}
        <div>
        <PriceInfo model={model} onUpdate={onUpdate} />
        </div>
        </div>

        {/* Rozwinięty konfigurator - pojawia się pod głównym layoutem */}
        {isConfigExpanded&& (
            <div className="model-expanded-config">
            <ModelConfig model={model} onUpdate={onUpdate} expanded={true} isConfigExpanded={isConfigExpanded} setIsConfigExpanded={setIsConfigExpanded}/>
            </div>
        )}
        </div>
        </div>
    );
};

export default ModelSection;
